import { Activity } from "./types";

export const activities: Activity[] = [
  {
    id: '1',
    channel: 'email',
    customer: { name: 'Sarah Johnson', company: 'Acme Corp', initials: 'SJ' },
    title: 'Email sent',
    description: 'Product demo video and pricing information',
    timestamp: '10 minutes ago',
    agent: 'Anshul Jain',
    attachments: 2,
    tag: 'Product Demo - Next Steps'
  },
  {
    id: '2',
    channel: 'whatsapp',
    customer: { name: 'Sarah Johnson', company: 'Acme Corp', initials: 'SJ' },
    title: 'WhatsApp conversation',
    description: 'Discussed pricing options and enterprise features',
    timestamp: '2 days ago',
    agent: 'Anshul Jain',
    duration: '25 min',
    messages: 0
  },
  {
    id: '3',
    channel: 'call',
    customer: { name: 'Michael Chen', company: 'TechStart Inc', initials: 'MC' },
    title: 'Phone call completed',
    description: 'Discovery call - discussed current challenges and solutions',
    timestamp: '1 hour ago',
    agent: 'Anshul Jain',
    duration: '30 min'
  },
  {
    id: '4',
    channel: 'ai-call',
    customer: { name: 'Jennifer Smith', company: 'Global Solutions', initials: 'JS' },
    title: 'AI qualification call',
    description: 'AI assistant completed initial qualification - High interest detected',
    timestamp: '3 hours ago',
    agent: 'AI Assistant',
    score: 0
  },
  {
    id: '5',
    channel: 'call',
    customer: { name: 'Sarah Johnson', company: 'Acme Corp', initials: 'SJ' },
    title: 'Discovery call scheduled',
    description: 'Initial discovery call - 30 minutes',
    timestamp: '2 weeks ago',
    agent: 'Anshul Jain'
  },
  {
    id: '6',
    channel: 'whatsapp',
    customer: { name: 'Robert Brown', company: 'Innovation Labs', initials: 'RB' },
    title: 'WhatsApp message',
    description: 'Answered technical questions about API integration',
    timestamp: '3 days ago',
    agent: 'Anshul Jain',
    messages: 8
  },
  {
    id: '7',
    channel: 'email',
    customer: { name: 'Michael Chen', company: 'TechStart Inc', initials: 'MC' },
    title: 'Email sent',
    description: 'Follow-up email with case studies and ROI calculator',
    timestamp: '1 day ago',
    agent: 'Anshul Jain',
    attachments: 3,
    tag: 'Case Studies & ROI Analysis'
  },
  {
    id: '8',
    channel: 'web-chat',
    customer: { name: 'Emily Davis', company: 'Creative Agency', initials: 'ED' },
    title: 'Web chat conversation',
    description: 'Pricing inquiry and feature comparison',
    timestamp: '5 hours ago',
    agent: 'Anshul Jain',
    duration: '18 min',
    messages: 15
  },
  {
    id: '9',
    channel: 'email',
    customer: { name: 'Jennifer Smith', company: 'Global Solutions', initials: 'JS' },
    title: 'Email received',
    description: 'Requested demo scheduling and additional information',
    timestamp: 'Today',
    agent: 'Jennifer Smith',
    tag: 'Demo Request'
  },
  {
    id: '10',
    channel: 'call',
    customer: { name: 'Robert Brown', company: 'Innovation Labs', initials: 'RB' },
    title: 'Product walkthrough',
    description: 'Detailed product demonstration and Q&A session',
    timestamp: '1 week ago',
    agent: 'Anshul Jain',
    duration: '45 min'
  },
  {
    id: '11',
    channel: 'email',
    customer: { name: 'Sarah Johnson', company: 'Acme Corp', initials: 'SJ' },
    title: 'Email sent',
    description: 'Contract and implementation timeline',
    timestamp: '1 week ago',
    agent: 'Anshul Jain',
    attachments: 2,
    tag: 'Contract & Timeline'
  }
];